import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.get("/api/users", { params });
}

const getUser = params => {
  return restApi.get("/api/user", { params });
}

const upsert = user => {
  return restApi.post("/api/user", user);
}

const deleteUser = ids => {
  return restApi.delete(`/api/users/${ids}`);
}

const getUserPostn = () => {
  return restApi.get("/api/user/postn");
}

const getUserRoles = () => {
  return restApi.get("/api/user/roles");
}

const getUserAccessRoles = params => {
  return restApi.get("/api/user/access-roles", { params });
}

const getUserBoard = () => {
  return restApi.get("/api/test/user");
};

const getManagerBoard = () => {
  return restApi.get("/api/test/manager");
};

const getAdminBoard = () => {
  return restApi.get("/api/test/admin");
};

const changeUserInfo = (username, firstName, lastName, dispName, deptName, jwtExpireSec) => {
  return restApi.post("/api/user/userinfo", { username, firstName, lastName, dispName, deptName, jwtExpireSec });
}

const changePassword = (username, oldPassword, newPassword, confirmPassword) => {
  return restApi.post("/api/user/password", { username, oldPassword, newPassword, confirmPassword });
}

const unlockUser = username => {
  return restApi.post("/api/user/unlock", username);
}

const logout = () => {
  return restApi.post("/api/user/logout");
}

const generateQRUrl = username => {
  return restApi.post("/api/user/qr-code", username);
}

const updateUserMfa = params => {
  return restApi.post("/api/user/mfa", params);
}

const userService = {
  getAll,
  getUser,
  upsert,
  deleteUser,
  getUserPostn,
  getUserRoles,
  getUserAccessRoles,
  getUserBoard,
  getManagerBoard,
  getAdminBoard,
  changeUserInfo,
  changePassword,
  unlockUser,
  logout,
  generateQRUrl,
  updateUserMfa
}

export default userService;